import React from 'react';
import { Heading, className } from 'soluble-design-system-base';
import ImageComponent from '../ImageComponent';

import style from './style.module.scss';

export default function HelpCategoryItem({ icon, title, cta }) {
    return (
        <a
            {...className(
                `d-flex flex-column align-items-start justify-content-between ${style.helpCategoryItem}`,
            )}
            aria-label={title}
            href={cta && cta.externalLink}>
            {icon?.contents ? (
                <div
                    dangerouslySetInnerHTML={{ __html: icon.contents }}
                    {...className(`${style.iconHelpCategory}`)}
                />
            ) : icon?.file?.publicURL ? (
                <ImageComponent
                    image={icon}
                    {...className(`${style.iconHelpCategory}`)}
                />
            ) : null}
            <Heading tag="h4" className={`h5 mb-3 mt-3 ${style.heading}`}>
                {title}
            </Heading>
        </a>
    );
}
